import React, { useEffect, useState } from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';

import request from '../../../utils/request';
import { FieldWrapper } from '../css';
import { uploadCustomerReadinessChecklist } from '../../../utils/constant';
import FileUpload from './components/fileUpload';
import FilesList from './components/filesList';

const FieldMultiFileUpload = ({ data, orderData }) => {
  const {
    name,
    label,
    required,
    allowedFileTypes,
    maximumFileSize,
    onChange,
    tooltip
  } = data;
  const { id: orderId } = orderData;
  const [filesList, setFilesList] = useState([]);

  useEffect(() => {
    if (orderId) {
      request.get(`/orders/${orderId}/files?typeId=${name}`).then(fileData => {
        const files = _.get(fileData, 'data.rows', []);
        setFilesList(files || []);
        onChange(
          { target: { name, value: (files && files.length > 0) ? [...files] : '', checked: false } },
          false,
          files.length > 0
        );
      });
    }
  }, [orderId]);

  const addFileToList = newFile => {
    setFilesList([...filesList, newFile]);
    onChange(
      { target: { name, value: [...filesList, newFile], checked: false } },
      true,
      true
    );
  };

  const removeFileFromList = id => {
    const updatedFileList = filesList.filter(file => file.fileId !== id);
    setFilesList(updatedFileList);
    onChange(
      { target: { name, value: '', checked: false } },
      true,
      updatedFileList.length > 0
    );
  };

  return (
    <FieldWrapper>
      {name === uploadCustomerReadinessChecklist &&
        filesList &&
        filesList.length > 0 ? null : (
        <FileUpload
          name={name}
          label={label}
          required={required}
          allowedFileTypes={allowedFileTypes}
          maximumFileSize={maximumFileSize}
          addFileToList={addFileToList}
          orderId={orderId}
          tooltip={tooltip}
        />
      )}
      {filesList && filesList.length > 0 && (
        <FilesList
          filesList={filesList}
          orderId={orderId}
          removeFileFromList={removeFileFromList}
        />
      )}
    </FieldWrapper>
  );
};

FieldMultiFileUpload.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.any).isRequired,
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.isRequired,
    label: PropTypes.string,
    required: PropTypes.bool,
    allowedFileTypes: PropTypes.string.isRequired,
    maximumFileSize: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    tooltip: PropTypes.string
  }).isRequired
};

export default FieldMultiFileUpload;
